/* **A photograph that dissolves into the ground it stands on** — no frame, no scrim, no words on
 * the picture. The treatment the assigned plan's Przegląd header drew first (owner, 28 September
 * 2026) and the personal-record task card draws second (2 October 2026), which is what promoted it
 * here: one declaration block in two features is this folder's.
 *
 * The same shape as `photoBox` beside it: a stylesheet with no component. The surface declares the
 * geometry — where the picture stands and how far it bleeds — and this declares the treatment;
 * nothing is declared on both sides.
 *
 * `.edge` enters from the leading side and fades out at its foot as well: two masks intersected, a
 * short feather on the leading edge and a long one at the bottom, so whatever stands below reads on
 * the ground and not on the picture. `.leading` is the leading feather alone, for a picture that
 * ends on its own box.
 *
 * The stops are the handoff's own alpha ramp. They are mask ALPHA, not a colour: a mask has no
 * token to read. `--photo-dim` is the dark theme's photographic treatment (`tokens/colors.css`). */

.edge {
  filter: var(--photo-dim);
  mask-composite: intersect;
  mask-image:
    linear-gradient(90deg, transparent 0%, transparent 2%, rgb(0 0 0 / 12%) 10%, rgb(0 0 0 / 38%) 18%, rgb(0 0 0 / 72%) 28%, #000 40%),
    linear-gradient(180deg, #000 0%, #000 56%, rgb(0 0 0 / 45%) 78%, transparent 100%);
}

.leading {
  filter: var(--photo-dim);
  mask-image: linear-gradient(90deg, transparent 0%, rgb(0 0 0 / 12%) 10%, rgb(0 0 0 / 38%) 18%, rgb(0 0 0 / 72%) 28%, #000 40%);
}
